import React from 'react';
import {
  TbFileInvoice,
  TbBuildingStore,
  TbBuildingWarehouse,
  TbBuildingBank,
  TbSettings,
  TbMan,
  TbShoppingCart,
  TbPaperBag,
  TbShoppingCartPlus,
  TbShoppingCartPause,
  TbShoppingCartStar,
  TbShoppingBag,
} from 'react-icons/tb';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import CheckroomOutlinedIcon from '@mui/icons-material/CheckroomOutlined';

const routesConfig = [
  {
    id: 'app',
    title: 'blueSoft Ventas',
    messageId: 'Bluesoft Ventas' /**sidebar.blueSoft.ventas**/,
    type: 'group',
    idsFuncionalidad: [
      '878',
      '606',
      '607',
      '608',
      '609',
      '602',
      '701',
      '610',
      '103',
      '611',
      '801',
      '803',
      '805',
      '805',
      '807',
      '809',
      '306',
      '307',
      '308',
      '322',
      '302',
      '310',
      '702',
      '309',
      '101',
      '802',
      '804',
      '806',
      '808',
      '810',
      '825',
      '843',
      '844',
      '739',
      '742',
      '743',
      '304',
      '312',
      '605',
      '502',
      '507',
      '524',
      '401',
      '403',
    ],
    children: [
      {
        id: 'nuevoCarrito',
        title: 'Nuevo Carrito',
        messageId: 'sidebar.blueSoft.newCart',
        type: 'item',
        url: '/blueSoft/carritos/NuevoCarrito',
        idsFuncionalidad: ['403'], //remplazar con el del carrito
        icon: <TbShoppingCartPlus />,
      },
      {
        id: 'carritoPendientes',
        title: 'Carritos Pendientes',
        messageId: 'sidebar.blueSoft.pendingCarts',
        type: 'item',
        url: '/blueSoft/ventas/carrito/pendientes',
        idsFuncionalidad: ['403'], //remplazar con el del carrito
        icon: <TbShoppingCartPause />,
      },
      {
        id: 'misVentas',
        title: 'Mis Ventas',
        messageId: 'sidebar.blueSoft.misVentas',
        type: 'item',
        url: '/blueSoft/ventas/MisVentas',
        idsFuncionalidad: ['603'],
        icon: <TbShoppingBag />,
      },
    ],

    // {
    //   id: 'ventas',
    //   title: 'Ventas',
    //   messageId: 'sidebar.blueSoft.sales',
    //   type: 'collapse',
    //   icon: <TbBuildingStore />,
    //   idsFuncionalidad: ['603'],
    //   children: [
    //     {
    //       id: 'pedidosDeVenta',
    //       title: 'Pedidos de Venta',
    //       messageId: 'sidebar.blueSoft.pedidosDeVenta',
    //       type: 'item',
    //       url: '/blueSoft/ventas/pedidos',
    //       idsFuncionalidad: ['603'],
    //       icon: <TbShoppingBag />,
    //     },
    //   ],
    // },
    // {
    //   id: 'ventas',
    //   title: 'Ventas',
    //   messageId: 'sidebar.blueSoft.sales',
    //   type: 'collapse',
    //   icon: <TbBuildingStore />,
    //   idsFuncionalidad: [
    //     '102',
    //     '606',
    //     '607',
    //     '608',
    //     '609',
    //     '602',
    //     '701',
    //     '610',
    //     '103',
    //     '611',
    //     '801',
    //     '803',
    //     '805',
    //     '805',
    //     '807',
    //     '809',
    //   ],
    //   children: [
    //     {
    //       id: 'pedidosDeVenta',
    //       title: 'Pedidos de Venta',
    //       messageId: 'sidebar.blueSoft.pedidosDeVenta',
    //       type: 'item',
    //       url: '/blueSoft/ventas/pedidos',
    //       idsFuncionalidad: ['603'],
    //       icon: <TbPaperBag />,
    //     },
    //     {
    //       id: 'clientes',
    //       title: 'Clientes',
    //       messageId: 'sidebar.blueSoft.clientes',
    //       type: 'item',
    //       url: '/blueSoft/ventas/clientes',
    //       idsFuncionalidad: ['103', '611'],
    //       icon: <TbMan />,
    //     },
    //     {
    //       id: 'productos',
    //       title: 'Productos',
    //       messageId: 'sidebar.blueSoft.productos',
    //       type: 'item',
    //       url: '/blueSoft/ventas/productos',
    //       idsFuncionalidad: ['102'],
    //       icon: <CheckroomOutlinedIcon />,
    //     },
    //     {
    //       id: 'analisisDeVentas',
    //       title: 'Análisis de Ventas',
    //       messageId: 'sidebar.blueSoft.analisisDeVentas',
    //       type: 'item',
    //       url: '/blueSoft/ventas/analisis',
    //       idsFuncionalidad: ['801', '803', '805', '805', '807', '809'],
    //       icon: <BarChartOutlinedIcon />,
    //     },
    //   ],
    // },
  },
];
export default routesConfig;
